import { render } from "./LayerNoConsent.vue?vue&type=template&id=0cdc498e&scoped=true&ts=true"
import script from "./LayerNoConsent.vue?vue&type=script&lang=ts"
export * from "./LayerNoConsent.vue?vue&type=script&lang=ts"

import "./LayerNoConsent.vue?vue&type=style&index=0&id=0cdc498e&scoped=true&lang=scss"

import exportComponent from "/home/gui/adm/gpp-cmp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cdc498e"]])

export default __exports__